<template>
    <div id="debug-sawlines-page">
        <ui5-button @click="$router.push('/debugmenu')">
            {{ trans('pages.debug_sawlines.back') }}
        </ui5-button>

        <div class="product-nr-entry">
            <ui5-label for="productNr">
                {{ trans('pages.debug_sawlines.enter_product_number') }}
            </ui5-label>
            <div>
                <ui5-input
                    type="Text"
                    name="productNr"
                    id="productNr"
                    :disabled="loading"
                    :value="productNr"
                    @input="productNr = $event.target.value"
                    @keyup.enter="fetchSawlines"
                />

                <ui5-button
                    @click="fetchSawlines"
                    :disabled="loading"
                >
                    {{ trans('pages.debug_sawlines.show_lines') }}
                </ui5-button>
            </div>
        </div>

        <spinner-text v-if="loading">
            {{ trans('pages.debug_sawlines.loading_sawlines') }}
        </spinner-text>

        <div
            v-else-if="sawlines"
            class="sawlines"
        >
            <div
                class="no-sawlines"
                v-if="sawlines.length == 0"
            >
                {{
                    trans('pages.debug_sawlines.no_sawlines_found', {
                        productNr: productNr,
                    })
                }}
            </div>
            <table v-else>
                <thead>
                    <tr>
                        <th>{{ trans('pages.debug_sawlines.table.id') }}</th>
                        <th>
                            {{
                                trans(
                                    'pages.debug_sawlines.table.external_name'
                                )
                            }}
                        </th>
                        <th>
                            {{
                                trans('pages.debug_sawlines.table.calculation')
                            }}
                        </th>
                        <th>{{ trans('pages.debug_sawlines.table.value') }}</th>
                        <th>
                            {{ trans('pages.debug_sawlines.table.cnc_code') }}
                        </th>
                        <th>
                            {{ trans('pages.debug_sawlines.table.profile') }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="line in sawlines"
                        :key="'line.' + line.id"
                    >
                        <td>{{ line.id }}</td>
                        <td>{{ line.externalName }}</td>
                        <td>
                            {{ line.datafield }} {{ line.addition }}
                            {{ line.constant }}
                        </td>
                        <td>{{ line.value }}</td>
                        <td>{{ line.CNCCode }}</td>
                        <td>
                            <a @click="backToProfilePage(line.profileId)">
                                {{ line.profileId }}
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import { stripNonNumeric } from '../helpers/StringHelpers';
import sawlineApi from '../api/sawline';
import SpinnerText from '../components/loader/SpinnerText';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    components: { SpinnerText },
    mixins: [localization],
    data() {
        return {
            productNr: '',
            loading: false,
            sawlines: null,
        };
    },
    methods: {
        backToProfilePage(profileId) {
            this.$router.push('/profilepage/' + profileId);
        },
        fetchSawlines() {
            this.sawlines = null;
            this.loading = true;
            sawlineApi
                .fetchSawlines(stripNonNumeric(this.productNr))
                .then((response) => {
                    this.sawlines = response.data.data;
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans(
                            'pages.debug_sawlines.error_fetching_sawlines'
                        )
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
